import { useNavigate } from 'react-router';
import Button from '../components/ui/Button';
import { ChevronLeftIcon, HomeIcon } from '@heroicons/react/24/outline';
import { Typography, Box } from '@mui/material';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <Box
        sx={{
          maxWidth: 448, // max-w-md equivalent
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: 160, // w-40 (larger circle)
            height: 160, // h-40 (larger circle)
            backgroundColor: theme => theme.statusBackgrounds.primaryMedium, // Brand color with transparency
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 8,
            border: theme => `2px solid ${theme.palette.primary.main}`, // Purple border with transparency
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: '4rem', // text-6xl equivalent
              fontWeight: 700,
              color: 'text.primary', // Brand accent color
              lineHeight: 1,
            }}
          >
            404
          </Typography>
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: 'text.primary', // Light text on dark background
            mb: 4,
          }}
        >
          Page Not Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: '1.125rem', // text-lg equivalent
            color: 'text.secondary',
            mb: 8,
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 4,
            justifyContent: 'center',
          }}
        >
          <Button
            onClick={() => navigate(-1)}
            variant="outlined"
            leftIcon={
              <ChevronLeftIcon
                style={{
                  fontSize: 20,
                  width: '20px',
                  height: '20px',
                  color: 'var(--mui-palette-text-primary)',
                }}
              />
            }
          >
            Go Back
          </Button>

          <Button
            onClick={() => navigate('/')}
            leftIcon={
              <HomeIcon
                style={{
                  fontSize: 20,
                  width: '20px',
                  height: '20px',
                  color: 'var(--mui-palette-text-primary)',
                }}
              />
            }
            variant="contained"
          >
            Return Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
